/**
 * 分数を表示用の文字列に変換する
 * 60 未満の場合は「X分」、それ以上の場合は「X時間Y分」の形式で返す
 *
 * @param minutes フォーマットする分数
 */
export const formatMinutes = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes}分`
  }
  return `${Math.floor(minutes / 60)}時間${minutes % 60}分`
}
